import "./LogoutNotif.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../features/authSlice.js";
import ApiService from "../Api_services";

const LogoutNotif = ({ onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Reset the login notif flag
    localStorage.removeItem("hasClosedLoginNotif");
    const session_key =
      localStorage.getItem("sso_session_key") ||
      localStorage.getItem("access_token") ||
      "";
    try {
      if (session_key) {
        await ApiService.logout(session_key);
      }
    } catch (err) {
      // swallow API errors, still proceed to clear client state
      console.error("Logout API error", err);
    } finally {
      // clear client state
      localStorage.removeItem("access_token");
      localStorage.removeItem("sso_session_key");
      localStorage.removeItem("customer_id");
      localStorage.removeItem("salesman_id");
      localStorage.removeItem("company_name");
      localStorage.removeItem("real_company_name");
      localStorage.removeItem("sub_role");
      dispatch(logout());
      navigate("/");
    }
  };

  const stopPropagation = (e) => e.stopPropagation();

  return (
    <div className="logoutnotif" onClick={onClose}>
      <div className="logoutnotif-content" onClick={stopPropagation}>
        <div className="lnclose-button">
          <button onClick={onClose}>&#10006;</button>
        </div>

        <div className="logoutnotif-title">
          <strong>Logout?</strong>
        </div>

        <div className="logoutnotif-main">Are you sure you want to logout?</div>

        <div className="logoutnotif-sub">
          <div className="no">
            <button onClick={onClose}>NO</button>
          </div>
          <div className="yes">
            <button onClick={handleLogout}>YES</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutNotif;
